import { config as devToolsConfig } from './config';
import { IS } from './util';

const console = window.console || {
  log: function() {
    return;
  },
  table: function() {
    return;
  },
  clear: function() {
    return;
  }
};

export let log: (...data: any[]) => void;
export let table: (...data: any[]) => void;
let clear: () => void;

export function initLogs() {
  if (IS.ie) {
    // ie 不支持緩存使用 log 等方法
    log = (...args: any[]) => {return console.log(...args);};
    table = (...args: any[]) => {return console.table(...args);};
    clear = () => {return console.clear();};
    return;
  }
  log = console.log;
  table = console.table;
  clear = console.clear;
}

export function clearLog() {
  if (devToolsConfig.clearLog) {
    clear();
  }
}